import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { close as clearTools, getTools } from '@reducers/clampingTools';
import { connect } from 'react-redux';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { updateHeaderConfig } from '@reducers/details';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface BatchDetailsJobTimelineProps {
}

const BatchDetailsJobTimelineComponent: FC<BatchDetailsJobTimelineProps> = ({
  productionBatchStatistics,
  getNCFileById,
  getTools,
  clearTools,
  updateHeaderConfig,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.job}>
       <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const BatchDetailsJobsTimeline = connect(null, {
  getNCFileById,
  productionBatchStatistics,
  getTools,
  clearTools,
  updateHeaderConfig,
})(BatchDetailsJobTimelineComponent);

export { BatchDetailsJobsTimeline };
